export default __webpack_public_path__ + "static/media/Loaf_iPhoneX_Invite_Users_11_19_21.e9bca621.png";